import React from 'react';

import { ChipProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const Chip = ({ label, className }: ChipProps) => {
  return (
    <div
      className={classNames(
        'h-fit rounded-xl bg-customSurfaceContrastLow px-4 py-3 text-sm font-medium leading-4 backdrop-blur-2xl max-sm:text-[12px]',
        {},
        [className],
      )}
    >
      {label}
    </div>
  );
};
